import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Roles, UserPartialState } from '@tix/auth/state';
import { map, mergeMap } from 'rxjs/operators';
import * as AuthSelectors from '@tix/auth/state/selectors';
import * as CompanySelectors from '@tix/company/state/selectors';
import { UserStatus } from '@tix/shared/models';
import { Router } from '@angular/router';
import { TixCompanyPartialState } from '@tix/company/state';
import { TixStaffService } from '@tix/staff/state';

@Component({
  selector: 'tix-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: {
    class: 'tix-header'
  }
})
export class TixHeaderComponent implements OnInit {
  @Input() name = '';
  @Input() date: Date = new Date();
  @Output() toggleSidebar = new EventEmitter<void>();

  isLoggedIn: Observable<boolean>;

  userRoles: string;

  readonly companyName$: Observable<string | undefined> = this.store.select(
    CompanySelectors.getSelectedName
  );

  readonly companyId$: Observable<string | undefined> = this.store.select(
    CompanySelectors.getSelectedCompanyId
  );

  userRolesInCompany$ = this.companyId$.pipe(
    mergeMap(companyId =>
      this.staffService.getCurrentUserRolesInCompany(companyId as string)
    )
  );

  constructor(
    private readonly store: Store<TixCompanyPartialState>,
    private staffService: TixStaffService
  ) {}

  ngOnInit(): void {
    this.getUserRoles();
  }

  getUserRoles() {
    this.userRolesInCompany$
      .pipe(map(roles => roles.map(role => String(role))))
      .subscribe(roles => {
        const formatedRoles = roles
          .map(role =>
            role
              .split('_')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join('-')
          )
          .join(' | ');
        this.userRoles = formatedRoles;
      });
  }

  isAdmin(roles: Roles[]) {
    return roles.includes(Roles.CO_ADMIN);
  }

  onToggleSidebar(): void {
    this.toggleSidebar.emit();
  }
}
